/* tslint:disable */
/* eslint-disable */
/* @relayHash a77b38f659bda1c0491ff401294a489e */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type AllCommentsTabQueryVariables = {
    storyID?: string | null;
    storyURL?: string | null;
    commentsOrderBy?: COMMENT_SORT | null;
};
export type AllCommentsTabQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabContainer_viewer">;
    } | null;
    readonly story: {
        readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabContainer_story">;
    } | null;
    readonly settings: {
        readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabContainer_settings">;
    };
};
export type AllCommentsTabQuery = {
    readonly response: AllCommentsTabQueryResponse;
    readonly variables: AllCommentsTabQueryVariables;
};



/*
query AllCommentsTabQuery(
  $storyID: ID
  $storyURL: String
  $commentsOrderBy: COMMENT_SORT
) {
  viewer {
    ...AllCommentsTabContainer_viewer
    id
  }
  story: stream(id: $storyID, url: $storyURL) {
    ...AllCommentsTabContainer_story_H4pgm
    id
  }
  settings {
    ...AllCommentsTabContainer_settings
    id
  }
}

fragment AllCommentsTabContainer_settings on Settings {
  reaction {
    sortLabel
  }
  disableCommenting {
    enabled
  }
  featureFlags
  ...ReplyListContainer1_settings
  ...CommentContainer_settings
  ...PostCommentFormContainer_settings
  ...ViewersWatchingContainer_settings
}

fragment AllCommentsTabContainer_story_H4pgm on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
    mode
  }
  commentCounts {
    totalPublished
  }
  comments(first: 20, orderBy: $commentsOrderBy) {
    edges {
      node {
        id
        ...CommentContainer_comment
        ...ReplyListContainer1_comment
        ...IgnoredTombstoneOrHideContainer_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...PostCommentFormContainer_story
  ...CommentContainer_story
  ...ReplyListContainer1_story
  ...CreateCommentReplyMutation_story
  ...CreateCommentMutation_story
  ...ViewersWatchingContainer_story
}

fragment AllCommentsTabContainer_viewer on User {
  ...ReplyListContainer1_viewer
  ...CommentContainer_viewer
  ...CreateCommentReplyMutation_viewer
  ...CreateCommentMutation_viewer
  ...IgnoredTombstoneOrHideContainer_viewer
  ...PostCommentFormContainer_viewer
  status {
    current
  }
}

fragment CaretContainer_comment on Comment {
  id
  ...ModerationDropdownContainer_comment
}

fragment CaretContainer_settings on Settings {
  ...ModerationDropdownContainer_settings
}

fragment CaretContainer_story on Story {
  ...ModerationDropdownContainer_story
}

fragment CaretContainer_viewer on User {
  ...ModerationDropdownContainer_viewer
}

fragment CommentContainer_comment on Comment {
  id
  author {
    id
    username
    avatar
    badges
  }
  parent {
    author {
      username
      id
    }
    id
  }
  body
  createdAt
  status
  editing {
    edited
    editableUntil
  }
  tags {
    code
  }
  deleted
  actionCounts {
    reaction {
      total
    }
  }
  viewerActionPresence {
    dontAgree
    flag
  }
  ...ReplyCommentFormContainer_comment
  ...EditCommentFormContainer_comment
  ...ReactionButtonContainer_comment
  ...ReportFlowContainer_comment
  ...ReportButton_comment
  ...CaretContainer_comment
  ...RejectedTombstoneContainer_comment
  ...UserTagsContainer_comment
  ...UsernameWithPopoverContainer_comment
  ...UsernameContainer_comment
  ...MediaSectionContainer_comment
}

fragment CommentContainer_settings on Settings {
  disableCommenting {
    enabled
  }
  featureFlags
  ...CaretContainer_settings
  ...ReportFlowContainer_settings
  ...ReactionButtonContainer_settings
  ...ReplyCommentFormContainer_settings
  ...EditCommentFormContainer_settings
  ...UserTagsContainer_settings
  ...MediaSectionContainer_settings
  ...UsernameWithPopoverContainer_settings
}

fragment CommentContainer_story on Story {
  url
  isClosed
  canModerate
  settings {
    mode
  }
  ...CaretContainer_story
  ...ReplyCommentFormContainer_story
  ...PermalinkButtonContainer_story
  ...EditCommentFormContainer_story
  ...UserTagsContainer_story
}

fragment CommentContainer_viewer on User {
  id
  status {
    current
  }
  ignoredUsers {
    id
  }
  badges
  role
  scheduledDeletionDate
  mediaSettings {
    unfurlEmbeds
  }
  ...UsernameWithPopoverContainer_viewer
  ...ReactionButtonContainer_viewer
  ...ReportFlowContainer_viewer
  ...ReportButton_viewer
  ...CaretContainer_viewer
}

fragment CreateCommentMutation_story on Story {
  settings {
    moderation
  }
}

fragment CreateCommentMutation_viewer on User {
  role
  createdAt
  badges
  status {
    current
    ban {
      active
    }
  }
}

fragment CreateCommentReplyMutation_story on Story {
  settings {
    moderation
  }
}

fragment CreateCommentReplyMutation_viewer on User {
  role
  badges
  createdAt
  status {
    current
    ban {
      active
    }
  }
}

fragment EditCommentFormContainer_comment on Comment {
  id
  body
  createdAt
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
  }
  author {
    username
    id
  }
  editing {
    editableUntil
  }
  site {
    id
  }
}

fragment EditCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  media {
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    giphy {
      enabled
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
}

fragment EditCommentFormContainer_story on Story {
  id
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  author {
    id
    username
  }
}

fragment IgnoredTombstoneOrHideContainer_viewer on User {
  ignoredUsers {
    id
  }
}

fragment LocalReplyListContainer_comment on Comment {
  id
}

fragment LocalReplyListContainer_settings on Settings {
  ...CommentContainer_settings
}

fragment LocalReplyListContainer_story on Story {
  ...CommentContainer_story
}

fragment LocalReplyListContainer_viewer on User {
  ...CommentContainer_viewer
  ...IgnoredTombstoneOrHideContainer_viewer
}

fragment MediaSectionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment MediaSectionContainer_settings on Settings {
  media {
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    giphy {
      enabled
    }
    external {
      enabled
    }
  }
}

fragment MessageBoxContainer_story on Story {
  settings {
    messageBox {
      content
      icon
    }
    mode
  }
}

fragment ModerationActionsContainer_comment on Comment {
  id
  author {
    id
  }
  revision {
    id
  }
  status
  tags {
    code
  }
}

fragment ModerationActionsContainer_settings on Settings {
  auth {
    integrations {
      sso {
        enabled
        targetFilter {
          admin
        }
      }
    }
  }
}

fragment ModerationActionsContainer_story on Story {
  id
  settings {
    mode
  }
}

fragment ModerationActionsContainer_viewer on User {
  id
  moderationScopes {
    scoped
  }
}

fragment ModerationDropdownContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  status
  tags {
    code
  }
  ...ModerationActionsContainer_comment
  ...UserBanPopoverContainer_comment
}

fragment ModerationDropdownContainer_settings on Settings {
  ...ModerationActionsContainer_settings
}

fragment ModerationDropdownContainer_story on Story {
  id
  ...ModerationActionsContainer_story
  ...UserBanPopoverContainer_story
}

fragment ModerationDropdownContainer_viewer on User {
  ...ModerationActionsContainer_viewer
}

fragment PermalinkButtonContainer_story on Story {
  url
}

fragment PostCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  disableCommenting {
    enabled
    message
  }
  closeCommenting {
    message
  }
  media {
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    giphy {
      enabled
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
}

fragment PostCommentFormContainer_story on Story {
  id
  isClosed
  ...MessageBoxContainer_story
  site {
    id
  }
  settings {
    messageBox {
      enabled
    }
    mode
  }
}

fragment PostCommentFormContainer_viewer on User {
  id
  scheduledDeletionDate
}

fragment RTEContainer_config on RTEConfiguration {
  enabled
  strikethrough
  spoiler
  sarcasm
}

fragment ReactionButtonContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  viewerActionPresence {
    reaction
  }
  actionCounts {
    reaction {
      total
    }
  }
}

fragment ReactionButtonContainer_settings on Settings {
  reaction {
    label
    labelActive
    icon
    iconActive
  }
}

fragment ReactionButtonContainer_viewer on User {
  id
}

fragment RejectedTombstoneContainer_comment on Comment {
  id
}

fragment ReplyCommentFormContainer_comment on Comment {
  id
  site {
    id
  }
  author {
    username
    id
  }
  revision {
    id
  }
}

fragment ReplyCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  disableCommenting {
    enabled
    message
  }
  closeCommenting {
    message
  }
  media {
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    giphy {
      enabled
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
}

fragment ReplyCommentFormContainer_story on Story {
  id
  isClosed
}

fragment ReplyListContainer1_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...ReplyListContainer2_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer1_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListContainer2_settings
  ...CommentContainer_settings
}

fragment ReplyListContainer1_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListContainer2_story
  ...CommentContainer_story
}

fragment ReplyListContainer1_viewer on User {
  ...ReplyListContainer2_viewer
  ...CommentContainer_viewer
  ...IgnoredTombstoneOrHideContainer_viewer
}

fragment ReplyListContainer2_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...ReplyListContainer3_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer2_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListContainer3_settings
  ...CommentContainer_settings
}

fragment ReplyListContainer2_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListContainer3_story
  ...CommentContainer_story
}

fragment ReplyListContainer2_viewer on User {
  ...ReplyListContainer3_viewer
  ...CommentContainer_viewer
  ...IgnoredTombstoneOrHideContainer_viewer
}

fragment ReplyListContainer3_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...LocalReplyListContainer_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer3_settings on Settings {
  disableCommenting {
    enabled
  }
  ...LocalReplyListContainer_settings
  ...CommentContainer_settings
}

fragment ReplyListContainer3_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...CommentContainer_story
  ...LocalReplyListContainer_story
}

fragment ReplyListContainer3_viewer on User {
  ...CommentContainer_viewer
  ...IgnoredTombstoneOrHideContainer_viewer
  ...LocalReplyListContainer_viewer
}

fragment ReportButton_comment on Comment {
  id
  author {
    username
    id
  }
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment ReportButton_viewer on User {
  id
}

fragment ReportCommentFormContainer_comment on Comment {
  id
  revision {
    id
  }
}

fragment ReportCommentFormContainer_settings on Settings {
  memberBios
}

fragment ReportFlowContainer_comment on Comment {
  ...ReportCommentFormContainer_comment
  id
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment ReportFlowContainer_settings on Settings {
  ...ReportCommentFormContainer_settings
}

fragment ReportFlowContainer_viewer on User {
  id
}

fragment StaffTagContainer_settings on Settings {
  staff {
    staffLabel
    adminLabel
    moderatorLabel
  }
}

fragment UserBanPopoverContainer_comment on Comment {
  id
  revision {
    id
  }
  status
  author {
    id
    username
  }
}

fragment UserBanPopoverContainer_story on Story {
  id
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment UserPopoverContainer_settings on Settings {
  ...UserPopoverOverviewContainer_settings
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverContainer_viewer on User {
  ...UserPopoverOverviewContainer_viewer
}

fragment UserPopoverOverviewContainer_settings on Settings {
  memberBios
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
  bio
}

fragment UserPopoverOverviewContainer_viewer on User {
  id
  ignoredUsers {
    id
  }
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UserTagsContainer_settings on Settings {
  ...StaffTagContainer_settings
}

fragment UserTagsContainer_story on Story {
  settings {
    mode
  }
}

fragment UsernameContainer_comment on Comment {
  id
  author {
    username
    id
  }
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}

fragment UsernameWithPopoverContainer_settings on Settings {
  ...UserPopoverContainer_settings
}

fragment UsernameWithPopoverContainer_viewer on User {
  ...UserPopoverContainer_viewer
}

fragment ViewersWatchingContainer_settings on Settings {
  disableCommenting {
    enabled
  }
}

fragment ViewersWatchingContainer_story on Story {
  id
  viewerCount
  isClosed
  settings {
    live {
      enabled
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentsOrderBy"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyID"
    } as any), v2 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyURL"
    } as any), v3 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any),
        ({
            "kind": "Variable",
            "name": "url",
            "variableName": "storyURL"
        } as any)
    ], v4 = ({
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "commentsOrderBy"
    } as any), v5 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v6 = [
        (v5 /*: any*/)
    ], v7 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "badges",
        "storageKey": null
    } as any), v8 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v9 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
    } as any), v10 = [
        (v9 /*: any*/)
    ], v11 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "icon",
        "storageKey": null
    } as any), v12 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 20
        } as any),
        (v4 /*: any*/)
    ], v13 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v14 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            (v5 /*: any*/),
            (v13 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatar",
                "storageKey": null
            },
            (v7 /*: any*/),
            (v8 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignoreable",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v15 = ({
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    (v13 /*: any*/),
                    (v5 /*: any*/)
                ],
                "storageKey": null
            },
            (v5 /*: any*/)
        ],
        "storageKey": null
    } as any), v16 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
    } as any), v17 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any), v18 = ({
        "alias": null,
        "args": null,
        "concreteType": "EditInfo",
        "kind": "LinkedField",
        "name": "editing",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "edited",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editableUntil",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v19 = ({
        "alias": null,
        "args": null,
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v20 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
    } as any), v21 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionCounts",
        "kind": "LinkedField",
        "name": "actionCounts",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "kind": "LinkedField",
                "name": "reaction",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v22 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionPresence",
        "kind": "LinkedField",
        "name": "viewerActionPresence",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dontAgree",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flag",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reaction",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v23 = ({
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": (v6 /*: any*/),
        "storageKey": null
    } as any), v24 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v25 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v26 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v27 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v28 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentRevision",
        "kind": "LinkedField",
        "name": "revision",
        "plural": false,
        "selections": [
            (v5 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                    (v24 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v25 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                            },
                            (v26 /*: any*/),
                            (v27 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "still",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "video",
                                "storageKey": null
                            }
                        ],
                        "type": "GiphyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v25 /*: any*/),
                            (v26 /*: any*/)
                        ],
                        "type": "TwitterMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v25 /*: any*/),
                            (v26 /*: any*/),
                            (v27 /*: any*/)
                        ],
                        "type": "YouTubeMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v25 /*: any*/)
                        ],
                        "type": "ExternalMedia",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v29 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 10
        } as any),
        ({
            "kind": "Literal",
            "name": "orderBy",
            "value": "CREATED_AT_ASC"
        } as any)
    ], v30 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replyCount",
        "storageKey": null
    } as any), v31 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pending",
        "storageKey": null
    } as any), v32 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastViewerAction",
        "storageKey": null
    } as any), v33 = ({
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "localReplies",
        "plural": true,
        "selections": [
            (v5 /*: any*/),
            (v14 /*: any*/),
            (v15 /*: any*/),
            (v16 /*: any*/),
            (v8 /*: any*/),
            (v17 /*: any*/),
            (v18 /*: any*/),
            (v19 /*: any*/),
            (v31 /*: any*/),
            (v32 /*: any*/),
            (v20 /*: any*/),
            (v21 /*: any*/),
            (v22 /*: any*/),
            (v23 /*: any*/),
            (v28 /*: any*/)
        ],
        "storageKey": null
    } as any), v34 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enteredLive",
        "storageKey": null
    } as any), v35 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any), v36 = ({
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v37 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v35 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v5 /*: any*/),
                    (v30 /*: any*/),
                    (v34 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v8 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v31 /*: any*/),
                    (v32 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v28 /*: any*/),
                    (v33 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v38 = [
        "orderBy"
    ], v39 = ({
        "alias": null,
        "args": (v29 /*: any*/),
        "filters": (v38 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v40 = ({
        "kind": "ClientExtension",
        "selections": [
            (v31 /*: any*/),
            (v32 /*: any*/),
            (v34 /*: any*/)
        ]
    } as any), v41 = ({
        "alias": null,
        "args": (v29 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v37 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v5 /*: any*/),
                            (v30 /*: any*/),
                            (v34 /*: any*/),
                            (v14 /*: any*/),
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v8 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v31 /*: any*/),
                            (v32 /*: any*/),
                            (v20 /*: any*/),
                            (v21 /*: any*/),
                            (v22 /*: any*/),
                            (v23 /*: any*/),
                            (v28 /*: any*/),
                            (v33 /*: any*/),
                            (v24 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v35 /*: any*/)
                ],
                "storageKey": null
            },
            (v36 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
    } as any), v42 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v35 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v5 /*: any*/),
                    (v34 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v8 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v31 /*: any*/),
                    (v32 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v28 /*: any*/),
                    (v41 /*: any*/),
                    (v39 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v43 = ({
        "alias": null,
        "args": (v29 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v42 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v5 /*: any*/),
                            (v34 /*: any*/),
                            (v14 /*: any*/),
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v8 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v31 /*: any*/),
                            (v32 /*: any*/),
                            (v20 /*: any*/),
                            (v21 /*: any*/),
                            (v22 /*: any*/),
                            (v23 /*: any*/),
                            (v28 /*: any*/),
                            (v41 /*: any*/),
                            (v39 /*: any*/),
                            (v24 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v35 /*: any*/)
                ],
                "storageKey": null
            },
            (v36 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
    } as any), v44 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v35 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v5 /*: any*/),
                    (v34 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v8 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v31 /*: any*/),
                    (v32 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v28 /*: any*/),
                    (v43 /*: any*/),
                    (v39 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v45 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "AllCommentsTabQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AllCommentsTabContainer_viewer"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "story",
                    "args": (v3 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "stream",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                (v4 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "AllCommentsTabContainer_story"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AllCommentsTabContainer_settings"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "AllCommentsTabQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v5 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "current",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BanStatus",
                                    "kind": "LinkedField",
                                    "name": "ban",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "active",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "ignoredUsers",
                            "plural": true,
                            "selections": (v6 /*: any*/),
                            "storageKey": null
                        },
                        (v7 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scheduledDeletionDate",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserMediaSettings",
                            "kind": "LinkedField",
                            "name": "mediaSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "unfurlEmbeds",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserModerationScopes",
                            "kind": "LinkedField",
                            "name": "moderationScopes",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "scoped",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v8 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": "story",
                    "args": (v3 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "stream",
                    "plural": false,
                    "selections": [
                        (v5 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isClosed",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "closedAt",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorySettings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LiveConfiguration",
                                    "kind": "LinkedField",
                                    "name": "live",
                                    "plural": false,
                                    "selections": (v10 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mode",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StoryMessageBox",
                                    "kind": "LinkedField",
                                    "name": "messageBox",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "content",
                                            "storageKey": null
                                        },
                                        (v11 /*: any*/),
                                        (v9 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "moderation",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentCounts",
                            "kind": "LinkedField",
                            "name": "commentCounts",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalPublished",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v12 /*: any*/),
                            "concreteType": "CommentsConnection",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/),
                                                (v14 /*: any*/),
                                                (v15 /*: any*/),
                                                (v16 /*: any*/),
                                                (v8 /*: any*/),
                                                (v17 /*: any*/),
                                                (v18 /*: any*/),
                                                (v19 /*: any*/),
                                                (v20 /*: any*/),
                                                (v21 /*: any*/),
                                                (v22 /*: any*/),
                                                (v23 /*: any*/),
                                                (v28 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": (v29 /*: any*/),
                                                    "concreteType": "CommentsConnection",
                                                    "kind": "LinkedField",
                                                    "name": "replies",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Comment",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v5 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        (v15 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v8 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        (v19 /*: any*/),
                                                                        (v20 /*: any*/),
                                                                        (v21 /*: any*/),
                                                                        (v22 /*: any*/),
                                                                        (v23 /*: any*/),
                                                                        (v28 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": (v29 /*: any*/),
                                                                            "concreteType": "CommentsConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "replies",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "CommentEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Comment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v5 /*: any*/),
                                                                                                (v14 /*: any*/),
                                                                                                (v15 /*: any*/),
                                                                                                (v16 /*: any*/),
                                                                                                (v8 /*: any*/),
                                                                                                (v17 /*: any*/),
                                                                                                (v18 /*: any*/),
                                                                                                (v19 /*: any*/),
                                                                                                (v20 /*: any*/),
                                                                                                (v21 /*: any*/),
                                                                                                (v22 /*: any*/),
                                                                                                (v23 /*: any*/),
                                                                                                (v28 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": (v29 /*: any*/),
                                                                                                    "concreteType": "CommentsConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "replies",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "CommentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Comment",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v5 /*: any*/),
                                                                                                                        (v30 /*: any*/),
                                                                                                                        (v14 /*: any*/),
                                                                                                                        (v15 /*: any*/),
                                                                                                                        (v16 /*: any*/),
                                                                                                                        (v8 /*: any*/),
                                                                                                                        (v17 /*: any*/),
                                                                                                                        (v18 /*: any*/),
                                                                                                                        (v19 /*: any*/),
                                                                                                                        (v20 /*: any*/),
                                                                                                                        (v21 /*: any*/),
                                                                                                                        (v22 /*: any*/),
                                                                                                                        (v23 /*: any*/),
                                                                                                                        (v28 /*: any*/),
                                                                                                                        (v24 /*: any*/),
                                                                                                                        {
                                                                                                                            "kind": "ClientExtension",
                                                                                                                            "selections": [
                                                                                                                                (v31 /*: any*/),
                                                                                                                                (v32 /*: any*/),
                                                                                                                                (v33 /*: any*/),
                                                                                                                                (v34 /*: any*/)
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v35 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v36 /*: any*/),
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                (v37 /*: any*/)
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                                                },
                                                                                                (v39 /*: any*/),
                                                                                                (v24 /*: any*/),
                                                                                                (v40 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v35 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v36 /*: any*/),
                                                                                {
                                                                                    "kind": "ClientExtension",
                                                                                    "selections": [
                                                                                        (v42 /*: any*/)
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                        },
                                                                        (v39 /*: any*/),
                                                                        (v24 /*: any*/),
                                                                        (v40 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v35 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v36 /*: any*/),
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                (v44 /*: any*/)
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                },
                                                (v39 /*: any*/),
                                                (v24 /*: any*/),
                                                (v40 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v35 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v36 /*: any*/),
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CommentEdge",
                                            "kind": "LinkedField",
                                            "name": "viewNewEdges",
                                            "plural": true,
                                            "selections": [
                                                (v35 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v34 /*: any*/),
                                                        (v5 /*: any*/),
                                                        (v14 /*: any*/),
                                                        (v15 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v18 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v31 /*: any*/),
                                                        (v32 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v21 /*: any*/),
                                                        (v22 /*: any*/),
                                                        (v23 /*: any*/),
                                                        (v28 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": (v29 /*: any*/),
                                                            "concreteType": "CommentsConnection",
                                                            "kind": "LinkedField",
                                                            "name": "replies",
                                                            "plural": false,
                                                            "selections": [
                                                                (v44 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "CommentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Comment",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v5 /*: any*/),
                                                                                (v34 /*: any*/),
                                                                                (v14 /*: any*/),
                                                                                (v15 /*: any*/),
                                                                                (v16 /*: any*/),
                                                                                (v8 /*: any*/),
                                                                                (v17 /*: any*/),
                                                                                (v18 /*: any*/),
                                                                                (v19 /*: any*/),
                                                                                (v31 /*: any*/),
                                                                                (v32 /*: any*/),
                                                                                (v20 /*: any*/),
                                                                                (v21 /*: any*/),
                                                                                (v22 /*: any*/),
                                                                                (v23 /*: any*/),
                                                                                (v28 /*: any*/),
                                                                                (v43 /*: any*/),
                                                                                (v39 /*: any*/),
                                                                                (v24 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v35 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v36 /*: any*/)
                                                            ],
                                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                        },
                                                        (v39 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v12 /*: any*/),
                            "filters": (v38 /*: any*/),
                            "handle": "connection",
                            "key": "Stream_comments",
                            "kind": "LinkedHandle",
                            "name": "comments"
                        },
                        (v23 /*: any*/),
                        (v25 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canModerate",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "viewerCount",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReactionConfiguration",
                            "kind": "LinkedField",
                            "name": "reaction",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sortLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "label",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "labelActive",
                                    "storageKey": null
                                },
                                (v11 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "iconActive",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DisableCommenting",
                            "kind": "LinkedField",
                            "name": "disableCommenting",
                            "plural": false,
                            "selections": [
                                (v9 /*: any*/),
                                (v45 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "featureFlags",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Auth",
                            "kind": "LinkedField",
                            "name": "auth",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AuthIntegrations",
                                    "kind": "LinkedField",
                                    "name": "integrations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SSOAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "sso",
                                            "plural": false,
                                            "selections": [
                                                (v9 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AuthenticationTargetFilter",
                                                    "kind": "LinkedField",
                                                    "name": "targetFilter",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "admin",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "memberBios",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharCount",
                            "kind": "LinkedField",
                            "name": "charCount",
                            "plural": false,
                            "selections": [
                                (v9 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "min",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "max",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CloseCommenting",
                            "kind": "LinkedField",
                            "name": "closeCommenting",
                            "plural": false,
                            "selections": [
                                (v45 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaConfiguration",
                            "kind": "LinkedField",
                            "name": "media",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TwitterMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "twitter",
                                    "plural": false,
                                    "selections": (v10 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "YouTubeMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "youtube",
                                    "plural": false,
                                    "selections": (v10 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GiphyMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "giphy",
                                    "plural": false,
                                    "selections": (v10 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ExternalMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "external",
                                    "plural": false,
                                    "selections": (v10 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "RTEConfiguration",
                            "kind": "LinkedField",
                            "name": "rte",
                            "plural": false,
                            "selections": [
                                (v9 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "strikethrough",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "spoiler",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sarcasm",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StaffConfiguration",
                            "kind": "LinkedField",
                            "name": "staff",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "staffLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "adminLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "moderatorLabel",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v5 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "a77b38f659bda1c0491ff401294a489e",
            "metadata": {},
            "name": "AllCommentsTabQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '20ee8c5be7d22f1d1fb6dc097ddbc282';
export default node;
